import type { ProgrammeStage } from '@sparkapp/shared-types';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui/dialog';
import { STAGE_LABELS } from './programmeLabels';

interface ChangeProgrammeStageModalProps {
  open: boolean;
  programmeName: string;
  from: ProgrammeStage;
  to: ProgrammeStage;
  effect: string;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export function ChangeProgrammeStageModal({
  open,
  programmeName,
  from,
  to,
  effect,
  onClose,
  onConfirm,
  isLoading,
}: ChangeProgrammeStageModalProps) {
  const danger = to === 'concluded';
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen && !isLoading) onClose();
      }}
    >
      <DialogContent data-testid="programme-stage-modal" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-[20px]">Change programme status?</DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-3">
              <p className="font-semibold text-pine-ink">{programmeName}</p>
              <p className="font-semibold text-pine-ink" data-testid="programme-stage-transition">
                {STAGE_LABELS[from]} → {STAGE_LABELS[to]}
              </p>
              <p>{effect}</p>
              <p>This takes effect immediately for every family.</p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <button
            data-testid="programme-stage-cancel"
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] border-pine-line text-pine-ink-soft hover:bg-pine-hover-button transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            data-testid="programme-stage-confirm"
            data-danger={danger}
            onClick={onConfirm}
            disabled={isLoading}
            className={
              danger
                ? 'px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] border-pine-danger text-pine-danger hover:bg-pine-danger hover:text-white transition-colors disabled:opacity-50'
                : 'px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] border-pine-pine text-pine-pine hover:bg-pine-hover-button transition-colors disabled:opacity-50'
            }
          >
            {isLoading ? 'Saving...' : `Change to ${STAGE_LABELS[to]}`}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
